export default __webpack_public_path__ + "static/media/deeplearning_contribute.73e4cc8b.png";